export const env = {
  baseUrl: 'https://admin.yallalebanon.com',
};

